import { SwitchBackgroundProcessorOptions } from 'features/VirtualBackground/source';
import isNil from 'lodash/isNil';
import { PROCESSOR_TYPES, ProcessorInfo } from '../types';

export const getOptionsFromProcessorInfo = (
    processorInfo: ProcessorInfo | null,
): SwitchBackgroundProcessorOptions | null => {
    if (isNil(processorInfo)) {
        return null;
    }

    const { type } = processorInfo;

    if (type === PROCESSOR_TYPES.none) {
        return {
            mode: 'disabled',
        };
    }

    if (type === PROCESSOR_TYPES.blur) {
        const { blurRadius } = processorInfo;
        return { mode: 'background-blur', blurRadius };
    }

    if (type === PROCESSOR_TYPES.image) {
        const { fullSrc } = processorInfo;
        return { mode: 'virtual-background', imagePath: fullSrc };
    }

    const unknownAction: never = type;
    throw new Error(`Wrong processor type: ${unknownAction}`);
};

export const checkIsSameProcessorApplied = (
    currentProcessorInfo: ProcessorInfo | null,
    newProcessorInfo: ProcessorInfo | null,
) => {
    // Оба null - одинаковые
    if (currentProcessorInfo === null && newProcessorInfo === null) return true;
    // Один null, второй - нет, значит разные.
    if (currentProcessorInfo === null || newProcessorInfo === null) return false;
    // Различаются типом - значит разные
    if (currentProcessorInfo.type !== newProcessorInfo.type) return false;
    // Тип none - одинаковые
    if (currentProcessorInfo.type === PROCESSOR_TYPES.none) return true;
    // Типы blur совпадают только если совпадает радиус размытия
    if (currentProcessorInfo.type === PROCESSOR_TYPES.blur && newProcessorInfo.type === PROCESSOR_TYPES.blur) {
        return currentProcessorInfo.blurRadius === newProcessorInfo.blurRadius;
    }
    // Типы image совпадают только если совпадает src изображения
    if (currentProcessorInfo.type === PROCESSOR_TYPES.image && newProcessorInfo.type === PROCESSOR_TYPES.image) {
        return currentProcessorInfo.fullSrc === newProcessorInfo.fullSrc;
    }

    return false;
};
